import { gql } from "@apollo/client";

const DELETE_TEAM = gql`
  mutation removeTeam($id: Int!) {
    removeTeam(id: $id) {
      id
    }
  }
`;

export default DELETE_TEAM;
